/* jshint undef: true, unused: true */
/* globals require */

var FoBuComponentFactory = require('./fobu-component-factory');

function addSelectOptions (element, componentSettings,  selectedOption, foBu) {
  var options       = componentSettings.options,
      defaultOption = (componentSettings.attributes.placeholder || false);

  var multiSelect = componentSettings.attributes.multiple;

  function setSelected(option) {
    foBu.addAttributes(option, {'selected' : 'selected'});
  }

  // Functions to check whether option is selected.
  function isSelectedSingle(optionValue, selectedValue) {
    return selectedValue && selectedValue === optionValue;
  }
  function isSelectedMultiple(optionValue, selectedValue) {
    return Array.isArray(selectedValue)
      ? selectedValue.indexOf(optionValue) > -1
      : false;
  }
  function isSelected(optionValue, selectedValue) {
    return multiSelect
      ? isSelectedMultiple(optionValue, selectedValue)
      : isSelectedSingle(optionValue, selectedValue);
  }

  if (defaultOption) {
    options = $.extend( {}, {'' : defaultOption}, options );
  }

  Object.keys(options).map(function (value) {
    var label  = options[value],
        option = document.createElement('option');


    foBu.addAttributes(option, {
      'value' : value,
      'label' : label
    });

    // If nothing is selected, set default.
    if (defaultOption && label === defaultOption) {
      foBu.addAttributes(option, {'disabled' : 'disabled'});
      if (!selectedOption) {
        setSelected(option);
      }
    }

    // If the current value is selected, set the option.
    if (isSelected(value, selectedOption)) {
      setSelected(option);
    }

    element.appendChild(option);
  });

  return element;
}



module.exports = function component (componentSettings, foBu) {

  var componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper,
      value            = foBu.existingValues[componentSettings.attributes.name];

  element = addSelectOptions(element, componentSettings || {}, value || null, foBu);

  wrapper.appendChild(element);


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
